<template>
    <div class="hot-service" @click="toServiceDetail">
      <div class="banner">
        <img :src="model.hotPic | formatImgUrl(550,550,true)" alt="" />
      </div>
      <div class="service-info">
        <div class='price_cont'>
          <!-- <div class="tag f28">服务</div> -->
          <div class="name f36">{{model.name}}</div>
          <div class="price f40">{{model.priceText}}</div>
        </div>
        <div>
          <div class="detail f28">{{model.hotContent}}</div>
          
        </div>
      </div>
    </div>
</template>

<script>
  import filters from '@/assets/js/filters'
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'hot-service',
    props: {
      model : {
        type : Object,
        default : ()=>{
          return {}
        }
      }
    },
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    methods: {
      toServiceDetail () {

        this.$router.push({ name: 'serviceDetail',query:{serviceId:this.model.id}})
      }
    }
  }
</script>

<style scoped lang="scss">
.price_cont{
  display: flex;
  justify-content: space-between;
}
.detail{
  font-size: 24px;
  color:#666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
  .hot-service{
    width: 100%;
    box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
    border-radius:6px;
    .banner{
      width: 100%;
      height: 460px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .service-info{
      // padding: 20px 30px 10px;
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 32px;
      padding-bottom: 20px;
      &>div{
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        &:last-child{
          justify-content: space-between;
        }
        .tag{
          width: 84px;
          height: 34px;
          background: #333;
          color: #fff;
          line-height: 34px;
          text-align: center;
          border-radius:4px;
          margin-right: 12px;
        }
        .name{
          line-height: 50px;
          font-weight: 500;
        }
        .price{
          line-height: 50px;
          font-family: Futura Medium;
          font-weight: bold;
        }
      }
    }
  }
</style>
